import { Fragment, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
import Resize from "src/components/common/resize";

import magnifierImg from "src/img/magnifier.png";
import UserInfo from "src/components/common/userInfo";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import {
    getDatefromWeekNum, getDatefromWeekNum0, 
    weeknum, boolAndReducer, getTimeStamp, 
    MyDate, simpleStatusColorCode, 
    myAxios, MyFormData, scroll, isDevMode,
    appTitle
} from "src/components/common/functions";
import Detail from "./detail";
import FilterForm from "./filter";
import Export from "./export";
import PurchaseForm from "./purchaseForm";
import WeekSelect from "../common/frame/weekSelect";

const title = "Purchases";
//--------------------------------------------------------------------------------------------
export default function Purchases({ tabTitle }){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const [updateDateTime, setUpdateDateTime] = useState(getTimeStamp());
    //--------------------------------------------------------------------------------------------
    const defaultFilter = {
        paid: "All", 
        billed: "All",
        status: "All",
        void: "", 
        createdBy: "", 
        updatedBy: "", 
        requestedBy: "",
        paymentMethod: "",
        totalMin: "",
        totalMax: "",
        billable: "",
        includedInProposal: "",
        projectName: "",
        approver: "",
        notes: "",
        poDateMin: "",
        poDateMax: "",
        submitTimeMin: "",
        submitTimeMax: "",
        dateUpdatedMin: "",
        dateUpdatedMax: ""
    };
    const [curFilter, setFilter] = useState(defaultFilter);
    const [showFilter, setShowFilterForm] = useState(false);
    const [curApproval, setApproval] = useState("");
    //--------------------------------------------------------------------------------------------
    const [curWeekStart, setWeekStart] = useState(weeknum(new MyDate()));
    const [curWeekEnd, setWeekEnd] = useState(weeknum(new MyDate()));
    const [purchaseList, setPurchaseList] = useState([]);
    const [showLoading, setShowLoading] = useState(false);
    const [usersList, setUsersList] = useState([]);
    const usersListMap = Object.fromEntries(usersList.map(user => [user.email, user]));
    const [vendorList, setVendorList] = useState([]);
    const [paymentMethodsData, setPaymentMethodsData] = useState({ paymentMethods: [], types: [] });
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [filterWords, setFilterWords] = useState("");
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    //--------------------------------------------------------------------------------------------
    const deleteUser = async e => {
        const poNumber = e.currentTarget.id;
        if(!window.confirm("Are you sure to void this PO?")) return;
        let voidReason = window.prompt("reason to void:");
        if(voidReason === null) return;
        while(voidReason === ""){
            window.alert("Reason is required to void.");
            voidReason = window.prompt("reason to void:");
            if(voidReason === null) return;
        }
        const formData = new MyFormData();
        formData.append("poNumber", poNumber);
        formData.append("voidReason", voidReason);
        //-----------------------------------
        setShowLoader(true);
        const res = await myAxios("purchases/deletePurchase.php", formData);
        setShowLoader(false);
        if(!res) return;
        //-----------------------------------
        setPurchaseList(purchaseList.map(purchase => 
            purchase.poNumber === poNumber?
            {...purchase, void: "yes", voidReason: voidReason}
            :
            purchase
        ));
        history.replace(`/${title}`);
        scroll(null);
    }
    const restoreUser = async e => {
        const poNumber = e.currentTarget.id;
        if(!window.confirm("Are you sure to re-valid this PO?")) return;
        let validReason = window.prompt("reason to valid:");
        if(validReason === null) return;
        if(validReason === ""){
            window.alert("Reason is required to valid.");
            validReason = window.prompt("reason to valid:");
            if(validReason === null) return;
        }
        const formData = new MyFormData();
        formData.append("poNumber", poNumber);
        formData.append("validReason", validReason);
        //-----------------------------------
        setShowLoader(true);
        const res = await myAxios("purchases/restorePurchase.php", formData);
        setShowLoader(false);
        if(!res) return;
        //-----------------------------------
        setFilter(filter => ({...filter, void: ""}));
        setPurchaseList(purchaseList.map(purchase => 
            purchase.poNumber === poNumber?
            {...purchase, void: "", voidReason: ""}
            :
            purchase
        ));
        history.push(`/${title}/${poNumber}`);
        setTimeout(() => {
            scroll(poNumber);
        }, 200);
    }
    const notify = async e => {
        const poNumber = e.currentTarget.id;
        if(window.confirm("Are you sure to notify the approver?")){
            const formData = new MyFormData();
            formData.append("poNumber", poNumber);
            //-----------------------------------
            setShowLoader(true);
            const res = await myAxios("purchases/notify.php", formData);
            setShowLoader(false);
            if(!res) return;
            //-----------------------------------
            setPurchaseList(purchaseList.map(purchase => 
                purchase.poNumber === poNumber?
                {...purchase, notify: new MyDate().s() + " " +  new MyDate().ss()}
                :
                purchase
            ));
            history.push(`/${title}/${poNumber}`);
            setTimeout(() => {
                scroll(poNumber);
            }, 200);
        }
    }
    const handleSubmit = async e => {
        e.preventDefault();
        const formData = new MyFormData(e.currentTarget);
        if(formData.get("poInvalid")){
            window.alert("PO number duplicated.");
            return;
        }
        formData.append("read", `no`);
        const requestor = usersListMap[formData.get("requestorEmail")];
        formData.append("requestor", `${requestor.userName}`);
        //-----------------------------------
        setShowLoader(true);
        const res = await myAxios(formData.get("action") === "Add"?
            "purchases/createPurchase.php":
            "purchases/updatePurchase.php", 
            formData
        );
        setShowLoader(false);
        if(!res) return;
        //-----------------------------------
        if(formData.get("action") === "Add"){
            setPurchaseList([...purchaseList, res.data]);
            history.push(`/${title}/${res.data.poNumber}`);
            setCurrentPage(Math.ceil(purchaseList.length / itemsPerPage));
            setTimeout(() => {
                scroll(res.data.poNumber);
            }, 200);
        }else{
            setPurchaseList(purchaseList.map(localPurchase => 
                localPurchase.poNumber === formData.get("prePoNumber")?
                res.data
                :
                localPurchase
            ));
            history.push(`/${title}/${res.data.poNumber}`);
            setTimeout(() => {
                scroll(res.data.poNumber);
            }, 200);
        }
    }
    //--------------------------------------------------------------------------------------------
    const pathname = history.location.pathname + (history.location.hash ?? "");
    const id = pathname.split("/")[2];
    const idid = pathname.split("/")[3];
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filterUserList = purchaseList?.map(purchase => 
        ({...purchase, 
            decision:
                JSON.parse(purchase.approval).some(level => level.approverDecision === "Rejected")?
                "Rejected"
                :
                JSON.parse(purchase.approval).every(level => level.approverDecision === "Approved")?
                "Approved"
                :
                "Submitted",
            approval: JSON.stringify(JSON.parse(purchase.approval).map(level => ({
                ...level, 
                candidate: (level.candidateEmail || []).map(singleCandidateEmail => usersListMap[singleCandidateEmail]?.label)
            }))), 
            submitter: usersListMap[purchase.submitterEmail]?.label, 
            updater: usersListMap[purchase.updaterEmail]?.label, 
            requestor: usersListMap[purchase.requestorEmail]?.label, 
            btlNumber: usersListMap[purchase.requestorEmail]?.btlNumber
        })
    ).filter(purchase => 
        (curFilter.void === "All"?true:(purchase.void === curFilter.void))
        && (curFilter.createdBy?purchase.submitterEmail === curFilter.createdBy:true)
        && (curFilter.updatedBy?purchase.updaterEmail === curFilter.updatedBy:true)
        && (curFilter.requestedBy?purchase.requestorEmail === curFilter.requestedBy:true)
        && (curFilter.paid === "All"?true:purchase.paid === curFilter.paid)
        && (curFilter.billed === "All"?true:purchase.billed === curFilter.billed)
        && (curFilter.status === "All"?true:purchase.decision === curFilter.status)
        && (curApproval?
            (
                JSON.parse(purchase.approval).some(level => 
                    (level.candidateEmail || []).includes(user.email)
                ) 
                &&
                (curApproval === "need"?
                    JSON.parse(purchase.approval).some(level => 
                        level.approverDecision !== "Approved"
                    )
                    :
                    true
                )
            )
            :
            true
        )
        && (curFilter.paymentMethod?purchase.paymentMethod === curFilter.paymentMethod:true)
        && (curFilter.billable?purchase.billable === curFilter.billable:true)
        && (curFilter.billable && curFilter.includedInProposal?purchase.includedInProposal === curFilter.includedInProposal:true)
        && (curFilter.totalMin?window.Number.parseFloat(purchase.total) >= window.Number.parseFloat(curFilter.totalMin):true)
        && (curFilter.totalMax?window.Number.parseFloat(purchase.total) <= window.Number.parseFloat(curFilter.totalMax):true)
        && (curFilter.projectName?purchase.projectName.toLowerCase().indexOf(curFilter.projectName) > -1:true)
        && (curFilter.notes?purchase.notes.toLowerCase().indexOf(curFilter.notes.toLowerCase()) > -1:true)
        && (curFilter.approver?curFilter.approver.split(" ").map(aa => purchase.approval.toLowerCase().indexOf(aa) > -1).reduce(boolAndReducer, true):true)
        && (curFilter.poDateMin?new Date(purchase.poDate) >= new Date(curFilter.poDateMin):true)
        && (curFilter.poDateMax?new Date(purchase.poDate) <= new Date(curFilter.poDateMax):true)
        && (curFilter.submitTimeMin?new Date(purchase.submitTime) >= new Date(curFilter.submitTimeMin):true)
        && (curFilter.submitTimeMax?new Date(purchase.submitTime) <= new Date(curFilter.submitTimeMax):true)
        && (curFilter.dateUpdatedMin?new Date(purchase.dateUpdated) >= new Date(curFilter.dateUpdatedMin):true)
        && (curFilter.dateUpdatedMax?new Date(purchase.dateUpdated) <= new Date(curFilter.dateUpdatedMax):true)
        && (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(purchase)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    );
    const currentUserList = filterUserList.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filterUserList.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    // Fetch payment methods once on mount
    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();
        const getPaymentMethods = async() => {
            setShowLoading(true);
            const resPaymentMethods = await myAxios("paymentMethods/readPaymentMethods.php", undefined, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resPaymentMethods) return;
            //-----------------------------------
            const newData = {
                paymentMethods: resPaymentMethods.data?.data?.paymentMethods || resPaymentMethods.data?.paymentMethods || [],
                types: resPaymentMethods.data?.data?.types || resPaymentMethods.data?.types || []
            };
            setPaymentMethodsData(newData);
        }
        getPaymentMethods();
        return () => {
            isMounted = false;
            controller.abort();
        }
    },[updateDateTime]);
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();
        const getData = async() => {
            //-----------------------------------
            setShowLoading(true);
            const resUsers = await myAxios("purchases/readSides.php", undefined, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resUsers) return;
            //-----------------------------------
            setUsersList(resUsers.data.users.map(user => ({...user, value: user.email, label:user.userName})));
            setVendorList(resUsers.data.vendors);
            //--------------------------------------------------------------------------------------------
            let po = "";
            if(id !== "Add" && id !== undefined && id !== "undefined"){
                const formData0 = new MyFormData();
                formData0.append("poNumber", id);
                //-----------------------------------
                setShowLoading(true);
                const poRes = await myAxios("purchases/readPurchase.php", formData0, undefined, controller.signal);
                if(!isMounted) return;
                setShowLoading(false);
                if(!poRes) return;
                //-----------------------------------
                if(poRes.data){
                    po = poRes.data;
                    if(po.void){setFilter(f => ({...f, void: "yes"}));}
                    
                    // Check if PO's submit time is within current week range
                    const poWeekNum = weeknum(po.submitTime.substring(0, 10));
                    const isWithinCurrentWeek = poWeekNum >= curWeekStart && poWeekNum <= curWeekEnd;
                    
                    // Only adjust week if PO is not in current week range
                    if(!isWithinCurrentWeek){
                        setWeekStart(poWeekNum);
                        setWeekEnd(poWeekNum);
                    }
                }else{
                    history.replace(`/${title}`);
                    scroll(null);
                }
            }
            //------------------------------------------------------------------------------------------------------
            const formData = new MyFormData();
            formData.append("start", getDatefromWeekNum(curWeekStart, 0));
            formData.append("end", getDatefromWeekNum(curWeekEnd, 7));
            //-----------------------------------
            setShowLoading(true);
            const res = await myAxios("purchases/readPurchases.php", formData, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //-----------------------------------
            setPurchaseList(res.data);
            if(po){
                setTimeout(() => {
                    scroll(id);
                }, 200);
            }
            setShowLoading(false);
        }
        getData();
        return () => {
            isMounted = false;
            setShowLoader(false);
            controller.abort();
        }
    },[curWeekStart, curWeekEnd, updateDateTime, id]);
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {title}
                    <span data-toggle = "tooltip" title = {"Refreshed on " + updateDateTime} className = "btn btn-primary py-1 ml-4" onClick = {() => setUpdateDateTime(getTimeStamp())}>↻</span>
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                {purchaseList.some(purchase =>
                    JSON.parse(purchase.approval).some(level => 
                        (level.candidateEmail || []).includes(user.email)
                    )
                )?
                <select className = "form-control w-auto" value = {curApproval} onChange = {e => {
                    setApproval(e.currentTarget.value);
                    setCurrentPage(1);
                }}>
                    <option value = "">All POs</option>
                    <option value = "all">All My Approval</option>
                    <option value = "need">Need My Approval</option>
                </select>
                :<></>}
                <WeekSelect
                    curWeekStart = {curWeekStart}
                    setWeekStart = {setWeekStart}
                    curWeekEnd = {curWeekEnd}
                    setWeekEnd = {setWeekEnd}
                    setCurrentPage = {setCurrentPage}
                    history = {history}
                    path1 = {title}
                    beginWeek = "2021/9/23"
                />
                <span className = "pointer rounded p-1" style = {{
                    backgroundColor: Object.entries(curFilter).some(([key, value]) => defaultFilter[key] !== value)?
                    "rgb(0,123,255)"
                    :""
                }} onClick = {() => {setShowFilterForm(true)}}>
                    Filter
                </span>
                {showFilter?
                <FilterForm
                    purchaseList = {purchaseList}
                    usersList = {usersList}
                    usersListMap = {usersListMap}
                    paymentMethodsData = {paymentMethodsData}
                    setCurrentPage = {setCurrentPage}
                    curFilter = {curFilter}
                    setFilter = {setFilter}
                    closeIt = {() => setShowFilterForm(false)}
                    defaultFilter = {defaultFilter}
                />:<></>}
                <Export
                    filterUserList = {filterUserList}
                    usersListMap = {usersListMap}
                />
                <span className = "pointer" onClick = {() => {history.push(`/${title}/Add`);}}>Add</span>
                {id === "Add"?
                (paymentMethodsData.types.length > 0?
                <PurchaseForm 
                    vendorList = {vendorList} 
                    handleSubmit = {handleSubmit} 
                    usersList = {usersList} 
                    usersListMap = {usersListMap}
                    paymentMethodsData = {paymentMethodsData}
                    closeIt = {() => history.push(`/${title}`)} 
                    keyword = "Add" 
                    action = "create"
                />
                :
                <div className = "cssLoading">Loading payment methods...</div>
                )
                :<></>}
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !filterUserList.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-responsive">
                    <table className = "table">
                        <thead>
                            <tr className = "noBorderTop">
                                <th></th>
                                <th>PO Type</th>
                                <th>Category</th>
                                <th>Project / Truck #</th>
                                <th>PO Number</th>
                                {user.projects !== "no"?<>
                                <th>Department</th>
                                <th>Requestor</th>
                                </>:<></>}
                                <th>Total</th>
                                <th>Form</th>
                                <th>Quotation</th>
                                <th>Receipt</th>
                                <th>Billable</th>
                                <th>Status</th>
                                <th>Paid</th>
                                <th>Billed</th>
                            </tr>
                        </thead>
                        <tbody>
                            
                            {currentUserList.map((purchase, key) => 
                            <Fragment key = {key}>
                            <tr
                                id = {purchase.poNumber}
                                style = {{
                                    color: simpleStatusColorCode[purchase.decision],
                                    cursor:"pointer"
                                }}
                                onClick = {e => {
                                    if(!e.target.id && e.target.tagName !== 'A'){
                                        const clickedId = e.currentTarget.id;
                                        if(!clickedId) return; // Safety check
                                        
                                        if(id !== clickedId){
                                            // Calculate which page this item is on in the filtered list
                                            const itemIndex = filterUserList.findIndex(p => p.poNumber === clickedId);
                                            if(itemIndex === -1) return; // Item not found in filtered list
                                            
                                            const correctPage = Math.ceil((itemIndex + 1) / itemsPerPage);
                                            
                                            // Set the page first, then navigate after a brief delay to ensure state updates
                                            if(correctPage !== currentPage){
                                                setCurrentPage(correctPage);
                                                setTimeout(() => {
                                                    history.push(`/${title}/${clickedId}`);
                                                    setTimeout(() => scroll(clickedId), 100);
                                                }, 50);
                                            }else{
                                                history.push(`/${title}/${clickedId}`);
                                                setTimeout(() => scroll(clickedId), 100);
                                            }
                                        }else{
                                            history.push(`/${title}`);
                                            scroll(null);
                                        }
                                    }
                                }}
                            >
                                <td className = {id === purchase.poNumber?"showMinus":"showPlus"}></td>
                                <td>{purchase.poType === "re"?"Reimbursement":"Purchase Request"}</td>
                                <td>{purchase.category}</td>
                                <td id = {purchase.projectHashKey || purchase.truckNumber || purchase.btlNumber}>
                                    {user.projects !== "no"?
                                        (purchase.projectHashKey?
                                            <Link  id = {purchase.projectHashKey} to = {`/Projects/${purchase.projectHashKey}`}>
                                                {purchase.projectName}
                                            </Link>
                                            :
                                            (purchase.truckNumber?
                                                JSON.parse(purchase.truckNumber).map((truck, truckIndex) => <li key = {truckIndex}>
                                                    <Link  id = {purchase.truckNumber} to = {`/Fleets/${truck.truckNumber}`}>
                                                        {truck.truckNumber}
                                                    </Link>
                                                </li>)
                                                :
                                                <Link  id = {purchase.btlNumber} style = {{color: "purple"}} to = {`/Personnel/${purchase.requestorEmail}`}>
                                                        {purchase.btlNumber}
                                                </Link>
                                            )
                                        )
                                        :
                                        (purchase.btlNumber ?? purchase.projectName)
                                    }
                                </td>
                                <td><span style = {{fontWeight: 650}}>{purchase.poNumber}</span></td>
                                {user.projects !== "no"?<>
                                <td>
                                    {purchase.department ?? usersListMap[purchase.requestorEmail]?.department}
                                </td>
                                <td id = {purchase.requestorEmail}>
                                    <UserInfo 
                                        name = {purchase.requestor}
                                        email = {purchase.requestorEmail}
                                    />
                                </td>
                                </>:<></>}
                                <td>{purchase.total}</td>
                                <td>
                                    {purchase.formId?
                                    <a
                                        id = {purchase.formId}
                                        className = "btn btn-primary"
                                        href = {`https://drive.google.com/file/d/${purchase.formId}/view`}
                                        target = "_blank"
                                        rel = "noreferrer"
                                    >
                                        Form
                                    </a>
                                    :<></>}
                                </td>
                                <td className = "text-center">
                                    {purchase.quoteLink && purchase.quoteLink !== "undefined"?
                                    <a
                                        id = {purchase.quoteLink}
                                        className = "btn btn-warning"
                                        href = {purchase.quoteLink}
                                        target = "_blank"
                                        rel = "noreferrer"
                                    >
                                        Quotation
                                    </a>:<></>}
                                </td>
                                <td>
                                    {purchase.receiptLink && purchase.receiptLink !== "undefined"?
                                    <a
                                        id = {purchase.quoteLink}
                                        className = "btn btn-info"
                                        href = {purchase.receiptLink}
                                        target = "_blank"
                                        rel = "noreferrer"
                                    >
                                        Receipt
                                    </a>:<></>}
                                </td>
                                <td>{purchase.billable}{purchase.includedInProposal === "Yes"?`, but included in proposal`:""}</td>
                                <td>
                                    {purchase.decision}
                                </td>
                                <td>{purchase.paid}</td>
                                <td>{purchase.billed}</td>
                            </tr>
                            <tr>
                                <td className = "noborder" colSpan = {100}>
                                <TransitionWidthHeight 
                                    classNames = "cssTDTransition"
                                    In = {id === purchase.poNumber}
                                >
                                    <Detail
                                        vendorList = {vendorList}
                                        setPurchaseList = {setPurchaseList}
                                        id = {id}
                                        idid = {idid}
                                        purchase = {purchase}
                                        history = {history}
                                        deleteUser = {deleteUser}
                                        restoreUser = {restoreUser}
                                        notify = {notify}
                                        handleSubmit = {handleSubmit}
                                        usersList = {usersList}
                                        usersListMap = {usersListMap}
                                        paymentMethodsData = {paymentMethodsData}
                                        curWeekStart = {curWeekStart}
                                        curWeekEnd = {curWeekEnd}
                                    />
                                    </TransitionWidthHeight>
                                </td>
                            </tr>
                            </Fragment>)}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && filterUserList.length?
                <Footer
                    length = {filterUserList.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
        </div>
    )
}